import React from 'react';
import { render } from 'react-dom';
import App from './components/App';

import getAppData from './utils/getAppData';

function buildChart($csv_chart_area, csv_download_url, papa_data) {
  render(
    <App data={getAppData(papa_data.data)} />,
    $csv_chart_area.get(0)
  );
}

export default buildChart;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/homework_test.js